<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 에이지락 미 History 상세 현황</h2>

      <h3 class="rew19_third_title">주문 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>리워드 번호</em>
          <span class="substance">{{$nvl(viewData.adr_no,"-")}}</span>
        </li>        
        <li class="type1">
          <em>결제일</em>
          <span class="substance">{{$nvl(viewData.payment_dt, "-")}}</span>
        </li>
        <li class="type1">
          <em>결제방법</em>
          <span class="substance">{{$nvl(viewData.payment_info, "-")}}</span>
        </li>
        <li class="type1">
          <em>진행회차</em>
          <span class="substance">
            총<span class="rew19_point">{{$fmt.PDCnt($nvl(viewData.payment_count,"0"))}}</span>회
          </span>
        </li>
        <li class="type1">
          <em>스킨케어 코드</em>
          <span class="substance">{{$nvl(viewData.agm_code, "-")}}</span>
        </li>        
        <li class="type1">
          <em>상태</em>
          <span class="substance">
            <span class="gep_btnRight">{{$nvl(viewData.status_name,"-")}}</span>
            <a v-if="viewData.showRepayment"
              @click="onClickCustomProductRePayment"
              class="rew19_btn_border">재결제</a>
            <template v-if="viewData.startKit_getInfo_show">
              <br/>
              -양도인 : {{viewData.startKit_getInfo_sender}}<br/>
              -양수 확인일 : {{viewData.startKit_getInfo_auth_date}}<br/>
            </template>
            <template v-if="viewData.startKit_sendInfo_show">
              <br/>
              -양수인 : {{viewData.startKit_sendInfo_getter}}<br/>
              -양수 확인일 : {{viewData.startKit_sendInfo_auth_date}}<br/>
            </template>
          </span>
        </li>
      </ul>

      <h3 class="rew19_third_title">배송 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>수령인</em>
          <span class="substance">{{viewData.ship_name}}</span>
        </li>
        <li class="type1">
          <em>전화 번호</em>
          <span class="substance">{{viewData.ship_tel}}</span>
        </li>
        <li class="type1">
          <em>핸드폰 번호</em>
          <span class="substance">{{viewData.ship_phone}}</span>
        </li>
        <li class="type1">
          <em>주소</em>
          <span class="substance">{{viewData.ship_addr}}</span>
        </li>
      </ul>

      <div v-if="viewData.delivery_status == '1'"
        class="rew19_responsive_btns gepTaye1">
        <a @click="onClickAgeLocMeDelivery" class="rew19-btn-normal">배송조회</a>
        <a @click="onClickGoList" class="rew19-btn-border">목록</a>
      </div>

      <div v-if="viewData.delivery_status != '1'"
        class="rew19_responsive_btns gepTaye1">        
        <a @click="onClickGoList" class="rew19-btn-normal">목록</a>
      </div>
    </div>
    <!--rew19_contents_inner-->

    <ageloc-repayment-dialog
      :show="agelocRepaymentDialogShow"      
      @close="agelocRepaymentClose"
      ref="agelocRepaymentDialog"
    ></ageloc-repayment-dialog>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import AgelocRepaymentDialog from '@/components/popup/AgelocRepaymentDialog';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

import DF from 'dateformat';

export default {
  name: "AgelocHistoryDetail",
  extends: AroBase,
  components: { AgelocRepaymentDialog },
  computed: {
    isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    }
  },
  props:{
    adr_no: {
      type: String,
      required: true
    },
    adr_order_no : {
      type: String,
      required: true
    },
    reqStartDate : {
      type: String,
      default : null
    },
    reqEndDate : {
      type: String,
      default : null
    }
  },
  data() { 
    return {     
      //View Data
      viewData : {
        status_name : ""
      },
      params : {},

      agelocRepaymentDialogShow : false,
      agelocRepaymentDialog : {},

      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;
    
    _this.loadDetail();
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },

    /**
     * API Request
     */
    //나의 에이지락 미 히스토리 정보 가져오기
    apiGetAgelocmeHistoryDetail(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_agelocme_history_detail`, {
        params: {
          adr_no : _this.adr_no,
          adr_order_no : _this.adr_order_no
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadDetail(){
      let _this = this;

      //show loading
      _this.$showLoading();      
      _this.apiGetAgelocmeHistoryDetail().then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {

          _this.viewData = {
            ...res.data
          };

          _this.adjustDetailData();
          
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //데이터 후처리
    adjustDetailData(){
      let _this = this;

      //초기값
      _this.viewData = {
        ..._this.viewData,
        status_name : "",
        showRepayment : false,
        startKit_getInfo_show : false,
        startKit_sendInfo_show : false,
      };
      //상품 확인
      let existAgmCode = _this.viewData.agm_code ? true: false;

      //결제 상태 
      let successPaymentCheck = "Y" == _this.viewData.payment_check;

      if(existAgmCode){
        // 커스텀 프로덕트 세트
        if("Y" == _this.viewData.adr_cancel){
          //철회된 상태
          _this.viewData.status_name="철회";
        }else{
          //Note:테스트 코드
				  //successPaymentCheck = false;
          if (successPaymentCheck) {
            //결제 완료
            _this.viewData.status_name="결제완료";
          } else {
            _this.viewData.status_name="결제실패";
            _this.viewData.showRepayment = true;
          }
        }
      }else{
        // 스타트 킷트
        if("Y" == _this.viewData.adr_cancel){
          //철회된 상태
          _this.viewData.status_name="철회";
        }else{
          //양수 양도 확인
          if (_this.AroConst.VALUE_transfer_status_GET == _this.viewData.transfer_status) {
            //양수
            _this.viewData = {
              ..._this.viewData,
              status_name : "양수완료",
              startKit_getInfo_show : true,
              startKit_getInfo_sender : 
                `${_this.$nvl(_this.viewData.send_name, "-")} (${_this.$nvl(_this.viewData.send_id, "-")})`,
              startKit_getInfo_auth_date : _this.$nvl(_this.viewData.auth_date, "-")
            };
            
          }else if(_this.AroConst.VALUE_transfer_status_SEND == _this.viewData.transfer_status) {
            //양도
             _this.viewData = {
              ..._this.viewData,
              status_name : "양도완료",
              startKit_sendInfo_show : true,
              startKit_sendInfo_getter : 
                `${_this.$nvl(_this.viewData.get_name, "-")} (${_this.$nvl(_this.viewData.get_id, "-")})`,
              startKit_sendInfo_auth_date : _this.$nvl(_this.viewData.auth_date, "-")
            };            
            
          }else {
            if (successPaymentCheck) {
              //결제 완료
              _this.viewData.status_name="결제완료";
            } else {
              _this.viewData.status_name="결제실패";//Note:스타트 킷트는 재결제 없음.              
            }            
          }
        }
      }
    },

    //커스텀 제품 재결제
    onClickCustomProductRePayment(){
      let _this = this;
     
      //재결제를 위한 Dialog open
      _this.agelocRepaymentDialog = {
        adr_no : _this.adr_no,
        adr_order_no : _this.adr_order_no,
        payment_target : _this.viewData.payment_target,
        payment_typ : _this.viewData.payment_typ,
      };
      _this.$refs.agelocRepaymentDialog.initData(_this.agelocRepaymentDialog);
      _this.agelocRepaymentDialogShow = true;  
    },

    //재결제 Popup close
    agelocRepaymentClose(isOk, data){
      let _this = this;

      _this.agelocRepaymentDialogShow = false;      

      if(!isOk){
        //Do nothing
        return;
      }

      //데이터 재로딩
      _this.loadDetail();
    },

    //배송 조회
    onClickAgeLocMeDelivery(){
      let _this = this;

      var delivery_link = "http://www.hanjinexpress.hanjin.net/customer/hddcw99nsk_m.tracking?r_num=";
      var sapNumber = _this.viewData.sap_order_no;

      if(sapNumber == null || sapNumber == undefined || sapNumber == ""){
        _this.$dialogs.alert("주문번호가 없습니다.")
        .then(res => {});
        return;
      }

      delivery_link += sapNumber;      
      window.open(delivery_link, "deliveryOrder", "width=553,height=270,scrollbars=no,left=50,top=50");      
    },

    //목록 이동
    onClickGoList(){
      let _this = this;
      let params = {
        reqStartDate : _this.reqStartDate,
        reqEndDate : _this.reqEndDate,
      };
      let qs = require('qs').stringify(params, {arrayFormat: 'brackets'});

      _this.$router.push(`${_this.$aroBasePath}/agelocHistoryList?${qs}`);
    }
  }
}
</script>
<style>
a.rew19-btn-normal, a.rew19-btn-normal, a.rew19_btn_border, a.rew19-btn-border{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ageloc/historyDetail.vue